export const actionChangeHandelModalAddPrice = (statusShow) => ({
    type: 'CHANGE_HANDEL_MODAL_ADD_PRICE',statusShow
});
export const actionChangeInputsModalAddPrice = (name,value) => ({
    type: 'CHANGE_INPUTS_MODAL_ADD_PRICE',name,value
});
